import { KoRichTextEditorReadOnly } from "packages";
import FeedAttachments from "../feedAttachments";
import styles from "../feed.module.scss";
export default function FeedPost({ post }) {
  return (
    <>
      {post.attachments?.length > 0 && (
        <FeedAttachments attachments={post.attachments} />
      )}
      <KoRichTextEditorReadOnly className={styles.messageCard} initialValues={post.text} />
    </>
  );
}
